import React from 'react';
import Gallery from 'react-photo-gallery';

import J1 from './images/jardin1.jpg'
import J3 from './images/jardin6.jpg'
import J4 from './images/jardin7.jpg'
import J5 from './images/jardin9.jpg'
import J6 from './images/jardin10.jpg'
import G1 from './images/garden1.jpg'
import G2 from './images/garden2.jpg'
import G3 from './images/garden3.jpg'
import G4 from './images/garden4.jpg'
import G5 from './images/garden5.jpg'
import G6 from './images/garden6.jpg'
import G7 from './images/garden7.jpg'
import G8 from './images/garden8.jpg'
import G9 from './images/garden9.jpg'
import G10 from './images/garden10.jpg'
import G11 from './images/garden11.jpg'
import P1 from './images/patio41.jpg'
import P2 from './images/patio43.jpg'

import Row from '../components/row';
import Title from '../components/title';

const photos = [
  { url: J1, aspectRatio: 1.2 },
  { url: J3, aspectRatio: 1.3 },
  { url: J4, aspectRatio: 1.5 },
  { url: J5, aspectRatio: 1.3 },
  { url: J6, aspectRatio: 1.5 },
  { url: P2, aspectRatio: 1.2 },
  { url: G9, aspectRatio: 1 },
  { url: G10, aspectRatio: 1.4 },
  { url: G11, aspectRatio: 1.1 },
  { url: G1, aspectRatio: 1.4 },
  { url: G2, aspectRatio: 1.5 },
  { url: G3, aspectRatio: 1.4 },
  { url: G4, aspectRatio: 1.2 },
  { url: P1, aspectRatio: 1.2 },
  { url: G5, aspectRatio: 1.5 },
  { url: G6, aspectRatio: 1.4 },
  { url: G7, aspectRatio: 1.2 },
  { url: G8, aspectRatio: 1.2 },
]
const preparePhoto = (photos) => {
  return photos.map(photo => ({
    src: photo.url,
    width: photo.width || 500,
    height: photo.height || 300,
    aspectRatio: photo.aspectRatio,
    lightboxImage: {
      src: photo.url
    }
  }))
};

const Garden = () => (
  <Row>
    <div className="mt30 text-center">
      <h1 >Nuestro Jardín</h1>
    </div>
    <Title title="El alma de El Capullo es verde" />
    <div>
      <Gallery photos={preparePhoto(photos)} />
    </div>
  </Row>
);

export default Garden;




// WEBPACK FOOTER //
// ./src/garden/index.js